<template>
  <section id="completeOrder">
    <div class="container q-px-xl">
      <div class="row q-col-gutter-lg">
        <div class="col-12 q-py-lg"></div>

        <div class="col-12">
          <breadcrumb :model-value="[{ name: 'Siparişi Ödeme', link: '' }]" />
        </div>

        <div class="col-lg-8">
          <!--    Delivery Address List Start   -->
          <div class="q-mb-xl">
            <div>
              <h3 class="order-completion--title">Adres</h3>
            </div>
            <div>
              <delivery-address-list :load-defaults="!orderId" :loading="loading || addressLoading" />
            </div>
          </div>
          <!--    ./Delivery Address List End   -->

          <!--     Order Summary Start    -->
          <div class="q-mb-lg">
            <div>
              <h3 class="order-completion--title">Sipariş Özeti</h3>
            </div>
            <div>
              <product-list-item :loading="loading" :list="list" />
            </div>
          </div>
          <!--     Order Summary End    -->

          <!--    Payment Start   -->
          <div class="q-mb-xl">
            <div>
              <h3 class="order-completion--title">Ödeme</h3>
            </div>
            <div>
              <h4 class="order-completion--subtitle">Ödeme Yöntemleri</h4>
            </div>
            <div>
              <payment-list v-model="paymentMethod" />
            </div>
            <div v-if="completeOrderInfo">
              <component
                v-if="paymentLoader"
                :is="paymentLoader"
                :order-info="completeOrderInfo.order_detail"
                :user-info="completeOrderInfo.user_detail"
                :general-info="completeOrderInfo.general_info"
                :address-info="completeOrderInfo.address_info"
              />
            </div>
            <!--            <div class="order-completion&#45;&#45;shopier">-->
            <!--              <p>Güvenli ödeme için Shopier sayfasına yönlendirileceksiniz.</p>-->
            <!--            </div>-->
          </div>
          <!--    ./Payment End   -->

          <!--     Inline Terms And Agreements Start     -->
          <div>
            <h4 class="order-completion--subtitle">Bilgilendirme</h4>
            <q-expansion-item group="termsAndAgreements" :model-value="true" class="q-px-none q-mb-md" style="border: 1px solid #ccc; border-radius: 8px">
              <template #header>
                <div class="q-item__section column q-item__section--main justify-center">
                  <div class="q-item__label text-weight-bold">📄 Tüketici Hakları – Cayma – İptal İade Koşulları</div>
                </div>
              </template>
              <template #default>
                <q-scroll-area class="q-px-md" style="height: 30vh">
                  <cancellation-and-refund-law :agreement-info="termsAndAgreementsInfo" />
                </q-scroll-area>
              </template>
            </q-expansion-item>
            <q-expansion-item group="termsAndAgreements" :model-value="false" class="q-px-none q-mb-md" style="border: 1px solid #ccc; border-radius: 8px">
              <template #header>
                <div class="q-item__section column q-item__section--main justify-center">
                  <div class="q-item__label text-weight-bold">📄 Kişisel Verilerin Korunması Bilgilendirme Metni</div>
                </div>
              </template>
              <template #default>
                <q-scroll-area class="q-px-md" style="height: 30vh">
                  <data-protection-law :agreement-info="termsAndAgreementsInfo" />
                </q-scroll-area>
              </template>
            </q-expansion-item>
          </div>
          <!--     Inline Terms And Agreements End     -->
        </div>
        <div class="col-lg-3">
          <div class="order-completion--actions">
            <div>
              <h3 class="order-completion--title">Ödenecek Tutar</h3>
            </div>
            <div class="order-completion--amount">
              <q-skeleton v-if="loading" type="text" width="80px" animation-speed="500" class="inline-block bg-grey" />
              <span v-else>{{ $numberToCurrency(getProductsTotal + Number(shippingCost)) }}</span> <span class="q-ml-sm">₺</span>
            </div>
            <div class="order-completion--amount_info-item">
              <div>
                <h5 class="order-completion--title_amount-info">{{ basketList.length > 1 ? 'Ürünler' : 'Ürün' }} Toplamı:</h5>
              </div>
              <div class="order-completion--amount-info">
                <q-skeleton v-if="loading" type="text" width="50px" animation-speed="500" class="inline-block" />
                <span v-else>{{ $numberToCurrency(getProductsTotal) }}</span> <span class="q-ml-sm">₺</span>
              </div>
            </div>
            <div v-if="getProductTaxTotal" class="order-completion--amount_info-item">
              <div>
                <h5 class="order-completion--title_amount-info">KDV Toplamı:</h5>
              </div>
              <div class="order-completion--amount-info">
                <q-skeleton v-if="loading" type="text" width="50px" animation-speed="500" class="inline-block" />
                <span v-else>{{ $numberToCurrency(getProductTaxTotal) }}</span> <span class="q-ml-sm">₺</span>
              </div>
            </div>
            <div class="order-completion--amount_info-item">
              <div>
                <h5 class="order-completion--title_amount-info">Kargo Bedeli:</h5>
              </div>
              <div class="order-completion--amount-info">
                <q-skeleton v-if="loading" type="text" width="50px" animation-speed="500" class="inline-block" />
                <span v-else>{{ $numberToCurrency(shippingCost) }}</span> <span class="q-ml-sm">₺</span>
              </div>
            </div>
            <q-separator class="q-my-md" />
            <div class="order-completion--terms">
              <div>
                <q-checkbox left-label v-model="terms" color="primary" size="2.5rem" />
              </div>
              <p>
                <a href="#" @click.prevent="agreements.preInformation = true">
                  <strong>Ön Bilgilendirme Formun'u</strong>
                </a>
                ve
                <a href="#" @click.prevent="agreements.distanceSales = true">
                  <strong>Mesafeli Satış Sözleşmesi'ni</strong>
                </a>
                onaylıyorum.
              </p>
            </div>
            <div class="order-completion--pay">
              <q-btn
                :disabled="paymentIsNotReady"
                class="full-width"
                color="primary"
                size="1.1rem"
                label="Ödeme Yap"
                :loading="makingPaymentLoading"
                @click="checkAndCreateOrder"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <terms-and-agreements
      v-model:pre-information="agreements.preInformation"
      v-model:distance-sales="agreements.distanceSales"
      :agreement-info="termsAndAgreementsInfo"
    />
  </section>
</template>

<script lang="ts">
import { computed, defineComponent, inject, onMounted, provide, reactive, type Ref, ref } from 'vue';
import { useRouter } from 'vue-router';
import { PageStore } from 'stores/Page/Page.ts';
import OrderService from 'src/core/services/OrderService';
import DeliveryAddressList from 'components/User/Order/Completion/DeliveryAddressList.vue';
import PaymentList, { PaymentMethod } from 'components/User/Order/Completion/PaymentList.vue';
import { BasketStore } from 'stores/Basket/Basket.ts';
import { storeToRefs } from 'pinia';
import ProductListItem from 'components/User/Order/ProductListItem.vue';
import TermsAndAgreements from 'components/User/Order/Completion/TermsAndAgreements.vue';
import { BasketProductItem } from 'src/core/types/Basket';
import ShopierPayment from 'components/User/Order/Payments/ShopierPayment.vue';
import { AddressesStore } from 'stores/Addresses/Addresses.ts';
import { useMeta, useQuasar } from 'quasar';
import DataProtectionLaw from 'components/User/Order/TermsAndAgreements/DataProtectionLaw.vue';
import CancellationAndRefundLaw from 'components/User/Order/TermsAndAgreements/CancellationAndRefundLaw.vue';
import Breadcrumb from 'components/Template/Breadcrumb.vue';

const paymentComponents = {
  shopier: ShopierPayment,
  // paypal: PaypalPayment,
  // creditcard: CreditCardPayment,
};

export default defineComponent({
  name: 'CompleteOrder',
  components: {
    Breadcrumb,
    CancellationAndRefundLaw,
    DataProtectionLaw,
    ShopierPayment,
    TermsAndAgreements,
    ProductListItem,
    PaymentList,
    DeliveryAddressList,
  },

  async preFetch({ store, currentRoute }) {
    const pageStore = PageStore(store);

    if (pageStore.content.value) {
      return;
    }

    await pageStore.getPage(currentRoute.path, currentRoute.query);
  },

  computed: {
    termsAndAgreementsInfo() {
      console.log(this.completeOrderInfo.order_detail);
      return {
        generalInfo: this.completeOrderInfo.general_info,
        orderInfo: this.orderId
          ? this.completeOrderInfo.order_detail
          : {
              products: this.basketList,
              orderdate: new Date().toDateString(),
              date: new Date().toDateString(),
              amount: this.getProductsTotal,
            },
        addressInfo: {
          shippingAddress: this.shippingAddress,
          billingAddress: this.billingAddress,
        },
        buyerInfo: this.me,
      };
    },
  },

  setup() {
    const $q = useQuasar();
    const $router = useRouter();

    const pageStore = PageStore();
    const { head, content } = storeToRefs(pageStore);

    const shippingCost = content.value.shippingCost;

    const me = inject<Ref<object>>('me');

    /**
     * Sepetten buraya geldiğinde ve :orderId yoksa o zaman sepetteki ürünler için gelmiş demektir.
     *
     * 1. Sepet'te olduğu gibi bu sayfayı çağırdığında arka tarafta yine checkInBasket süreci işleyecek. Açılır açılmaz
     * checkInBasket işlemi yapılacak.
     * 2. Eğer :orderId varsa, o zaman bu sayfa sipariş tamamlanma sayfasıdır. Yani mevcut sipariş üzerinden devam
     * edilecek. O zaman da checkInBasket yerine checkInOrder işlemi yapılacak. Order ödeme sürecine uygun bir status'u
     * taşıyor olmalı.
     */
    const basketStore = BasketStore();
    const { basketList, basketListLoading } = storeToRefs(basketStore);

    const addressStore = AddressesStore();
    const { shippingAddress, billingAddress } = storeToRefs(addressStore);

    const checkInBasketLoading = ref(false);
    const addressLoading = ref(false);

    const agreements = reactive({
      preInformation: false,
      distanceSales: false,
    });

    const terms = ref(false);

    const paymentMethod = ref<PaymentMethod | null>(null);
    const paymentLoader = ref(null);
    // const paymentComponents = import.meta.glob('src/components/User/Order/Payments/*Payment.vue');

    const {
      currentRoute: {
        value: {
          params: { orderId },
        },
      },
    } = $router;

    const list = ref([]);
    const listLoading = ref(false);
    const loading = computed(() => basketListLoading.value || listLoading.value);
    const productsTotal: Ref<{ [variationCode: number]: Ref<number> }> = ref({});
    const productQuantity: Ref<{ [variationCode: number]: Ref<number> }> = ref({});
    const productTax: Ref<{ [variationCode: number]: Ref<number> }> = ref({});

    const completeOrderInfo = ref({
      order_detail: {},
      user_detail: {},
      general_info: {},
      address_info: {
        shippingAddress: null,
        billingAddress: null,
      },
    });

    completeOrderInfo.value.general_info = content.value;
    completeOrderInfo.value.general_info.company = head.value.company;

    onMounted(() => {
      if (!orderId) {
        checkInUserBasket()
          .then(() => {
            if (basketList.value.length === 0) {
              $router.push('/basket');
            }
          })
          .then(() => {
            basketList.value.forEach((product: BasketProductItem) => {
              const [variation] = product.variations;
              productQuantity.value[variation.code] = ref(product.quantity);
              productsTotal.value[variation.code] = ref(variation.priceNumber);
              productTax.value[variation.code] = variation.priceInfo.tax > 0 ? variation.priceInfo.total.totalTaxNumber : 0;
            });
            list.value = basketList.value;
          });
      } else {
        listLoading.value = true;
        OrderService.orderPaymentCompletionDetail({ orderId: Number(orderId) })
          .then(({ status, data, message }) => {
            if (status._200_) {
              data.order_detail.products.forEach((product: BasketProductItem) => {
                const [variation] = product.variations;
                productQuantity.value[variation.code] = product.quantity;
                productsTotal.value[variation.code] = variation.priceNumber;
                productTax.value[variation.code] = variation.priceInfo.tax > 0 ? variation.priceInfo.total.totalTaxNumber : 0;
              });

              list.value = data.order_detail.products;

              completeOrderInfo.value.order_detail = data.order_detail;
              completeOrderInfo.value.user_detail = data.user_detail;

              shippingAddress.value = data.order_detail.address;
              billingAddress.value = data.order_detail.billing;

              completeOrderInfo.value.address_info.shippingAddress = shippingAddress.value;
              completeOrderInfo.value.address_info.billingAddress = billingAddress.value;
            } else {
              $q.notify({
                type: 'negative',
                message,
              });
              $router.push('/basket');
            }
          })
          .then(() => {
            listLoading.value = false;
          })
          .catch(() => {
            listLoading.value = false;
          });
      }
    });

    const getProductsTotal = computed(() => {
      const quantities = productQuantity.value;
      const taxes = productTax.value;
      return Object.entries(productsTotal.value)
        .map(([code, price]) => {
          const quantity = Number(quantities[code]);
          const tax = Number(taxes[code]);
          return price * quantity + tax * quantity;
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    });

    const getProductTaxTotal = computed(() => {
      const quantities = productQuantity.value;
      const taxes = productTax.value;
      return Object.entries(taxes)
        .map((o) => Number(o[1]) * Number(quantities[Number(o[0])]))
        .reduce((partialSum, a) => partialSum + a, 0);
    });

    const paymentIsNotReady = computed(() => !terms.value || checkInBasketLoading.value || basketListLoading.value || listLoading.value);

    const makingPaymentLoading = ref(false);

    provide('loadingState', {
      paymentIsNotReady,
      terms,
      checkInBasketLoading,
      basketList,
      listLoading,
      makingPaymentLoading,
    });

    useMeta({
      titleTemplate: (title) => `${title} | Sipariş Tamamla`,
    });

    function checkInUserBasket() {
      checkInBasketLoading.value = true;
      return basketStore
        .checkInBasket()
        .then(() => {
          if (!stockOutHasExists.value) {
            $router.push('complete-order');
          }
          checkInBasketLoading.value = false;
        })
        .catch(() => {
          checkInBasketLoading.value = false;
        });
    }

    return {
      me,
      $q,
      list,
      basketList,
      basketListLoading,
      loading,
      orderId,
      completeOrderInfo,
      terms,
      paymentMethod,
      paymentLoader,
      // paymentComponents,
      paymentIsNotReady,
      agreements,
      getProductsTotal,
      getProductTaxTotal,
      shippingCost,
      makingPaymentLoading,
      shippingAddress,
      billingAddress,
      addressLoading,
    };
  },

  methods: {
    async checkAndCreateOrder() {
      this.makingPaymentLoading = true;
      this.paymentLoader = null;
      if (this.orderId && this.completeOrderInfo) {
        this.getPaymentLoader().then(() => {
          this.makingPaymentLoading = false;
        });
      } else {
        if (!this.shippingAddress || !this.billingAddress) {
          this.$q.notify({
            type: 'warning',
            classes: 'text-weight-bold',
            message: 'Lütfen teslimat ve fatura adresi bilgilerinizi giriniz',
          });
          this.makingPaymentLoading = false;
          return;
        }

        OrderService.checkAndCreateOrder({
          addressId: this.shippingAddress?.id,
          billingAddressId: this.billingAddress?.id,
        })
          .then(({ status, data, message }) => {
            console.log(data);
            if (status._200_) {
              this.orderId = data.order_detail.id;

              this.completeOrderInfo.order_detail = data.order_detail;
              this.completeOrderInfo.user_detail = data.user_detail;
              this.completeOrderInfo.address_info.shippingAddress = data.order_detail.address;
              this.completeOrderInfo.address_info.billingAddress = data.order_detail.billing;
              this.shippingAddress = data.order_detail.address;
              this.billingAddress = data.order_detail.billing;

              this.getPaymentLoader().then(() => {
                this.makingPaymentLoading = false;
              });
            } else {
              this.$q.notify({
                type: 'negative',
                classes: 'text-weight-bold',
                message: message || 'Sipariş oluşturulamadı. Lütfen tekrar deneyiniz.',
              });
              this.makingPaymentLoading = false;
            }
          })
          .catch(() => {
            this.$q.notify({
              type: 'negative',
              classes: 'text-weight-bold',
              message: 'Sipariş oluşturulamadı. Lütfen tekrar deneyiniz.',
            });
            this.makingPaymentLoading = false;
          });
      }
    },

    getPaymentLoader() {
      return new Promise((resolve) => {
        if (this.paymentMethod) {
          const { id } = this.paymentMethod;
          // const compName = `${id.charAt(0).toUpperCase() + id.slice(1)}Payment.vue`;
          // const path = `src/components/User/Order/Payments/${compName}`;

          if (paymentComponents[id]) {
            this.paymentLoader = paymentComponents[id];
          } else {
            console.error(`Component not found: ${path}`);
          }
        }

        resolve(this.paymentLoader);
      });
    },

    // makePayment(orderId: string, paymentMethod: string) {
    //   return OrderService.makePayment({ orderId, paymentMethod });
    // },
  },

  watch: {
    shippingAddress(newVal) {
      if (this.completeOrderInfo.address_info.shippingAddress?.id === newVal?.id || !this.orderId) {
        return;
      }
      this.addressLoading = true;
      OrderService.changeAddress({
        orderId: Number(this.orderId),
        addressId: newVal?.id,
      })
        .then(({ status }) => {
          if (status._200_) {
            this.completeOrderInfo.address_info.shippingAddress = newVal;
            this.$q.notify({
              type: 'positive',
              message: 'Teslimat adresi güncellendi.',
            });
          } else {
            this.$q.notify({
              type: 'negative',
              message: 'Teslimat adresi güncellenemedi.',
            });
          }
          this.addressLoading = false;
        })
        .catch(() => {
          this.addressLoading = false;
        });
    },
    billingAddress(newVal) {
      if (this.completeOrderInfo.address_info.billingAddress?.id === newVal?.id || !this.orderId) {
        return;
      }
      this.addressLoading = true;
      OrderService.changeBillingAddress({
        orderId: Number(this.orderId),
        addressId: newVal?.id,
      })
        .then(({ status }) => {
          if (status._200_) {
            this.completeOrderInfo.address_info.billingAddress = newVal;
            this.$q.notify({
              type: 'positive',
              message: 'Fatura adresi güncellendi.',
            });
          } else {
            this.$q.notify({
              type: 'negative',
              message: 'Fatura adresi güncellenemedi.',
            });
          }
          this.addressLoading = false;
        })
        .catch(() => {
          this.addressLoading = false;
        });
    },
  },
});
</script>

<style scoped lang="sass">
.order-completion
  &--title
    font-size: 1.5rem
    font-weight: 700
    letter-spacing: 1px
    line-height: 1
    margin: 0.5rem 0 1.5rem

  &--amount
    display: flex
    align-items: center
    flex-wrap: nowrap
    font-size: 1.65rem
    font-weight: 500
    color: #000000
    padding: 0 .5rem
    margin-bottom: .75rem

  &--terms
    display: flex
    gap: 0.5rem
    margin-bottom: 1.5rem

    p
      font-size: 0.9rem
      font-weight: 600
      color: #666

      a
        text-decoration: none
        color: $blue-8

        &:hover
          text-decoration: underline

  &--actions
    padding: 1rem 1.5rem
    border-radius: 8px
    border: 1px solid #ccc

  &--pay ::v-global(.q-btn)
    letter-spacing: 1px

  &--shopier
    padding: 1.5rem 1rem
    background-color: $blue-2
    border-radius: 8px
    color: #666

    p
      margin: 0
      font-weight: 600
      font-size: 1rem
      color: #000000

  &--amount_info-item
    display: flex
    flex-wrap: nowrap
    align-items: center
    padding: 0 .5rem

  &--amount-info
    display: flex
    align-items: center
    flex-wrap: nowrap
    font-size: 1rem
    font-weight: 600
    color: #000000
    padding: 0 .5rem

  &--title_amount-info
    font-size: 1rem
    font-weight: 500
    color: #333
    margin: 0

  &--subtitle
    font-size: 1.2rem
    line-height: 1
    margin: 0
    font-weight: 500
    margin-bottom: 1.35rem
    color: #333
</style>
